import AbstractRepository from '@services/repositories/AbstractRepository';
import Cache from '@services/Cache';

export default class ProductRepository extends AbstractRepository {
    constructor() {
        super();
        this.setApiUrl('/vue/products');
    }

    async getById(id) {
        const res = await this.where('prod_id', id).run();
        return res.data[0];
    }

    async getAll() {
        if (Cache.get('products')) {
            return Cache.get('products');
        }

        return this.where('per_page', 10000).run().then((res) => {
            Cache.set('products', res.data);
            return Cache.get('products');
        });
    }
}
